import React from "react";
import Alert from "../common/Alert";

function FieldDetailsWarning({ message, dismissible }) {
  return (
    <Alert
      key="messageAlert"
      variant="warning"
      alertMessage={
        <div>
          <div className="field-details-warning">
            <strong>Warning</strong>
            <i
              className="fa fa-exclamation-circle yellow-warning-icon"
              aria-hidden="true"
            ></i>
          </div>
          <br />
          {message}
        </div>
      }
      dismissible={dismissible}
    />
  );
}

export default FieldDetailsWarning;
